import { render, staticRenderFns } from "./EditFichaLocal.vue?vue&type=template&id=a24dd34a&scoped=true&"
import script from "./EditFichaLocal.vue?vue&type=script&lang=js&"
export * from "./EditFichaLocal.vue?vue&type=script&lang=js&"
import style0 from "./EditFichaLocal.vue?vue&type=style&index=0&id=a24dd34a&scoped=true&lang=css&"
import style1 from "./EditFichaLocal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24dd34a",
  null
  
)

export default component.exports